import { Component, Inject, OnInit } from '@angular/core';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';

export interface SopoTreeButtonConfirmData {
    header?: string;
    allowText?: string;
    denyText?: string;
    continueText?: string;
}

@Component({
    selector: 'app-tree-button-confirm',
    templateUrl: './sopo-tree-button-confirm.component.html',
    styleUrls: ['./sopo-tree-button-confirm.component.scss'],
    standalone: false
})
export class SopoTreeButtonConfirmComponent implements OnInit {
    header: string = '';
    allowText: string = '';
    denyText: string = '';
    continueText: string = '';

    constructor(
        private sopoDialogRef: SopoDialogRef,
        @Inject(SOPO_DIALOG_DATA) data: SopoTreeButtonConfirmData,
    ) {
        if (data.header) this.header = data.header;
        if (data.denyText) this.denyText = data.denyText;
        if (data.allowText) this.allowText = data.allowText;
        if (data.continueText) this.continueText = data.continueText;
    }

    ngOnInit() {
    }

    async dontShow(event) {
        const itemKey = `dontShowAgain_locationPopup`;
        if (event.detail.checked) {
            localStorage.setItem(itemKey, 'true');
        } else {
            localStorage.removeItem(itemKey);
        }
    }

    allow() {
        this.sopoDialogRef.close('allow');
    }

    deny() {
        this.sopoDialogRef.close('deny');
    }

    continue() {
        this.sopoDialogRef.close('continue');
    }

    ngOnDestroy(): void {
    }
}
